module.exports = __webpack_public_path__ + "static/media/11.7eda4e7c.jpg";